import React from "react";
import { Bar } from "react-chartjs-2";

const SubjectAchievementChart = ({ achievementByYear }) => {
  const labels = Object.keys(achievementByYear);
  const dataValues = Object.values(achievementByYear);

  const data = {
    labels,
    datasets: [
      {
        label: " نسبة تحقيق",
        data: dataValues,
        borderColor: "#FFCE78",
        borderWidth: 0,
        backgroundColor: "#FFCE78",
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
    },
    scales: {
        yAxes: [
          {
            display: false,
            ticks: {
              beginAtZero: true,
              display: false,
              max: 100,
              min: 0,
              stepSize: 10,
            },
            gridLines: {
              display: false,
              drawBorder: false,
            },
          },
        ],
        xAxes: [
          {
            display: false,
            barPercentage: 0.2,      
            categoryPercentage: 0.2,
            barPercentage: 0.6,
            gridLines: {
              display: false,
              drawBorder: false,
            },
            ticks: {
              display: false,
            },
          },
        ],
      },
  };

  return (
    <div style={{ height: 150 }}>
      <Bar data={data} height={150} options={options} />
    </div>
  );
};

export default SubjectAchievementChart;
